import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomRadioButton from "../../CustomRadioButton";
import { Container } from "../../CreateWheelPopup.styled";
import {
  pushToHistoryAction,
  setIsLocked,
} from "../../../../redux/reducers/segmentBuilder";
import { getIsLocked } from "../../../../redux/selectors/segmentBuilderSelectors";
import TextView from "../../../TextView";

function Third() {
  const dispatch = useDispatch();
  const isLocked = useSelector(getIsLocked);

  useEffect(() => {
    dispatch(setIsLocked(isLocked == 1 ? 1 : 0));
  }, []);

  const handleLockedUnlockedChange = (event) => {
    dispatch(setIsLocked(event.target.value));
  };

  return (
    <Container>
      <TextView variant="title" style={{ textAlign: "center" }}>
        Limit Access
      </TextView>

      <TextView variant="subtitle" style={{ marginTop: "24px" }}>
        Lock your Wheel to restrict access or keep it Unlocked for anyone to
        see!
      </TextView>

      <CustomRadioButton
        options={[
          {
            value: 0,
            label: "Unlocked",
            tooltip: (
              <div>
                <TextView>
                  Unlocked Wheels can be accessed by anyone with the URL.
                </TextView>
              </div>
            ),
          },
          {
            value: 1,
            label: "Locked",
            tooltip: (
              <div>
                <TextView>
                  Locked Wheels can be Public or Private. <br />
                  Locked Wheels can be accessed via Password, Email Permissions,
                  or Payment (coming soon).
                </TextView>
              </div>
            ),
          },
        ]}
        selectedOption={isLocked}
        onChange={handleLockedUnlockedChange}
        orientation="vertical"
      />

      <TextView variant="text">
        {`*Further Lock Settings can be customized on the Wheel Builder under the Settings Tab > Accessibility.`}
      </TextView>
    </Container>
  );
}

export default Third;
